export class ErrorCode extends Error {
  code: string;
  constructor(code: string, ...args: any) {
    super(...args);
    this.code = code;
  }
}
